module.exports = __webpack_public_path__ + "static/media/AF8EA7D0-B6CE-49AC-9A3B-5D3E8B5EA553.8a8d6b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/AF8EA7D0-B6CE-49AC-9A3B-5D3E8B5EA553.jpg
// module id = 310
// module chunks = 0